<template lang="pug">
div
    BaseHeader(
        icon='el-icon-plus',
        exibeBotao,
        :titulo='$t("mensagens.gerenteRegional.labels.titulo")',
        :voltarPara='{ route: "ConfiguracaoRastreabilidade" }',
        :btnTexto='$t("mensagens.gerenteRegional.labels.novoGerente")',
        @btnHeaderClicado='irParaCadastroGerenteRegional'
    )
    .gerentes-regionais
        .field
            i.el-icon-search.field__icon
            input.input-search.field__input(
                v-model='filtro',
                type='text',
                :placeholder='$t("mensagens.gerenteRegional.labels.placeholder")',
                autocomplete='off',
                @keyup.enter='listarGerentesRegionais'
            )
        .lista
            h3.lista__titulo {{ $t('mensagens.gerenteRegional.labels.listagem') }}
            el-table.lista__tabela(:key="listagemTableKey('gerentes-regionais', lista, paginacao.pagina + 1)", :data='lista')
                el-table-column(
                    prop='id',
                    label='ID ERP',
                    width='200',
                    align='center'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.idBunge || '-' }}
                el-table-column(
                    prop='nome',
                    :label='$t("mensagens.gerenteRegional.labels.nomeLabel")'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.nome || '-' }}

                el-table-column(
                    :label='$t("mensagens.gerenteRegional.labels.acao")',
                    :min-width='15',
                    align='center'
                )
                    .template(slot-scope='scope')
                        el-dropdown.action-button(trigger='click')
                            span.el-dropdown-link
                                i.mdi.mdi-dots-vertical
                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    icon='el-icon-view',
                                    @click.native='irParaDetalhesGerenteRegional(scope.row, true)'
                                ) {{ $t('mensagens.gerenteRegional.labels.visualizar') }}
                                el-dropdown-item(
                                    icon='el-icon-edit',
                                    @click.native='irParaEdicaoGerenteRegional(scope.row)'
                                ) {{ $t('mensagens.gerenteRegional.labels.editar') }}
                                el-dropdown-item(
                                    icon='el-icon-delete',
                                    @click.native='confirmarRemocaoGerente(scope.row)'
                                ) {{ $t('mensagens.gerenteRegional.labels.excluir') }}
                template(slot='empty')
                el-empty(description='Não há fornacedores')
            .paginacao
                span.total-paginas {{ formatarTotalPaginas(paginacao.total) }}
                el-pagination(
                    background,
                    layout='prev, pager, next',
                    :page-size='paginacao.itensPorPagina',
                    :current-page.sync='paginacao.pagina + 1',
                    :total='paginacao.total',
                    @current-change='listarGerentesRegionais'
                )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import services from '@/services/ContratoOriginacaoService';

export default {
    name: 'GerentesRegionais',
    components: {
        BaseHeader
    },
    data() {
        return {
            filtro: '',
            pageable: {
                page: 0,
                size: 10,
                sort: 'nome',
                order: 'asc'
            },
            lista: [],
            paginacao: {}
        };
    },
    mounted() {
        this.listarGerentesRegionais();
    },
    methods: {
        async listarGerentesRegionais(page = 1) {
            this.pageable.page = page - 1;
            const params = {
                filtro: { nome: this.filtro },
                pageable: this.pageable
            };

            const { data } = await services.buscarGerentesRegionalPorFiltro(
                params
            );
            this.lista = data.gerentesRegionais;
            this.paginacao = data.paginacao;
        },
        irParaCadastroGerenteRegional() {
            this.$router.push({
                name: 'GerenteRegionalCadastro'
            });
        },
        irParaEdicaoGerenteRegional(row) {
            this.$router.push({
                name: 'GerenteRegionalEdicao',
                params: { row }
            });
        },
        irParaDetalhesGerenteRegional(row) {
            this.$router.push({
                name: 'GerenteRegionalDetalhes',
                params: { resume: row }
            });
        },
        confirmarRemocaoGerente(row) {
            const confirmButtonText = this.$t('mensagens.comuns.sim');
            const cancelButtonText = this.$t('mensagens.comuns.cancelar');
            const aviso = this.$t('mensagens.comuns.aviso');
            const mensagemRemocao = this.$t(
                'mensagens.sistema.removerGerenteRegional'
            );

            return this.$messageBox
                .confirm(mensagemRemocao, aviso, {
                    confirmButtonText,
                    cancelButtonText,
                    type: 'warning'
                })
                .then(result => {
                    if (result === 'confirm') {
                        this.removerGerenteRegional(row);
                    }
                });
        },
        removerGerenteRegional(row) {
            const { id, name } = row;
            const mensagemSucesso = this.$t(
                'mensagens.gerenteRegional.labels.registroExcluido'
            );

            services.removerGerenteRegional({ id, name }).then(({ data }) => {
                if (data.includes('sucesso')) {
                    this.$notify.success(mensagemSucesso);
                    this.listarGerentesRegionais();
                }
            });
        },
        formatarTotalPaginas(total = 0) {
            const title =
                total > 1
                    ? this.$t('mensagens.gerenteRegional.labels.titulo')
                    : this.$t(
                          'mensagens.gerenteRegional.labels.tituloSingular'
                      );

            return `${total} ${title}`;
        }
    }
};
</script>

<style lang="scss" scoped>
.gerentes-regionais {
    margin: 20px;
    .field {
        display: flex;
        background-color: $white;
        padding: 7px 10px;
        border-radius: $default-border-radius;
        gap: 5px;
        align-items: center;
        @include default-box-shadow();

        &__icon {
            color: $primary;
        }
        &__input {
            border: none;
            outline: none;
            width: 100%;
            &:focus,
            &:active {
                border: none;
            }
        }
    }
    .lista {
        margin-top: 20px;
        &__titulo {
            margin-bottom: 5px;
        }
        .el-table {
            border-radius: 4px 4px 0 0;
            @include default-box-shadow();
        }
    }
    .paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        background-color: $white;
        border-radius: 0 0 4px 4px;
        padding: 15px;

        .total-paginas {
            color: $primary;
            font-weight: bold;
        }
    }
}
</style>
